'use client'

import { OTPInput as OTPInputRoot, type SlotProps } from 'input-otp'
import * as React from 'react'
import { cn } from '@/lib/utils'

const OTP_SLOT_BASE =
  'flex h-12 flex-1 items-center justify-center rounded-lg text-center text-base font-medium transition-colors bg-[#FFF4F6]'
const OTP_SLOT_ACTIVE = 'border-[1.5px] border-[#B11739] outline-none'
const OTP_SLOT_INACTIVE = 'border border-transparent'

function Slot({ isActive, char, placeholderChar }: SlotProps) {
  return (
    <div className={cn(OTP_SLOT_BASE, isActive ? OTP_SLOT_ACTIVE : OTP_SLOT_INACTIVE)}>
      {char ?? placeholderChar}
    </div>
  )
}

const defaultRender = ({ slots }: { slots: SlotProps[] }) => (
  <>
    {slots.map((slot, idx) => (
      <Slot key={idx} {...slot} />
    ))}
  </>
)

export type InputOTPProps = {
  length?: number
  value?: string
  onChange?: (value: string) => unknown
  placeholder?: string
  containerClassName?: string
  render?: (props: { slots: SlotProps[] }) => React.ReactNode
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'maxLength'>

const InputOTP = React.forwardRef<HTMLInputElement, InputOTPProps>(
  ({ length = 4, containerClassName, render, ...props }, ref) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { children: _children, ...inputProps } = props
    return (
      <OTPInputRoot
        ref={ref}
        maxLength={length}
        containerClassName={cn('flex w-full gap-4', containerClassName)}
        render={render ?? defaultRender}
        {...inputProps}
      />
    )
  }
)
InputOTP.displayName = 'InputOTP'

export { InputOTP }
